import { ScoutDownloadPage } from '@/features/discovery/pages/scout-download-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/scout-download')({
  component: ScoutDownloadPage,
});
